import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/debug.module.css";

export default {
  "body": "debug-module__body_CV2CGa__010",
  "column": "debug-module__column_CV2CGa__010",
  "container": "debug-module__container_CV2CGa__010",
  "header": "debug-module__header_CV2CGa__010",
  "icon": "debug-module__icon_CV2CGa__010",
  "link": "debug-module__link_CV2CGa__010"
};
      